<template>
  <component
    v-if="componentName"
    :is="componentName"
    :widgetId="widgetId"
    :widgetType="widgetType"
    :widgetMaxDevices="widgetMaxDevices"
    :deviceIds="deviceIds"
    :width="width"
    :height="height"
    :settings="settings"
    :isDialog="isDialog"
    @close="close"
    @removeWidget="removeWidget"
    @refreshDashboard="refreshDashboard"
  />
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import PopoverWidget from './content/PopoverWidget.vue'
import ContinuousMonitoringAndStudyWidget from './content/ContinuousMonitoringAndStudyWidget.vue'
import { NAMESPACES } from '@/store/types'
import { DEVICE_GETTERS } from '@/store/devices'
import type { WidgetSettings } from '@/types/dashboard'
import type { WidgetComponentKey } from '@/views/dashboard.vue'

type ComponentName = 'PopoverWidget' | 'ContinuousMonitoringAndStudyWidget'

export default defineComponent({
  name: 'CurrentReadingsWidget',
  components: {
    PopoverWidget,
    ContinuousMonitoringAndStudyWidget
  },
  props: {
    widgetId: String,
    widgetType: String as PropType<WidgetComponentKey>,
    widgetMaxDevices: Object as PropType<Record<WidgetComponentKey, number> | null>,
    deviceIds: {
      type: Array as PropType<string[]>,
      default: (): string[] => []
    },
    width: Number,
    height: Number,
    settings: Object as PropType<WidgetSettings>,
    isDialog: Boolean
  },
  computed: {
    deviceId(): string {
      return this.deviceIds?.[0] || ''
    },
    serial(): string {
      return this.$store.getters[`${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_SERIAL_BY_DEVICE_ID}`](
        this.deviceId
      )
    },
    isDeviceConnectedToSmartBridge(): boolean {
      return this.$store.getters[
        `${NAMESPACES.DEVICES}/${DEVICE_GETTERS.IS_DEVICE_CONNECTED_TO_SMART_BRIDGE}`
      ](this.deviceId)
    },
    componentName(): ComponentName | '' {
      if (this.serial) {
        // If device information has finished saving in Vuex
        return this.isDeviceConnectedToSmartBridge
          ? 'ContinuousMonitoringAndStudyWidget'
          : 'PopoverWidget'
      }

      return ''
    }
  },
  methods: {
    close(): void {
      this.$emit('close')
    },
    removeWidget(options: unknown): void {
      this.$emit('removeWidget', options)
    },
    refreshDashboard(): void {
      this.$emit('refreshDashboard')
    }
  }
})
</script>
